(function () {
  'use strict';

  var STORAGE_KEY = 'localWishlist';
  var renderToken = 0;

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.map(String).filter(function (handle, index, arr) {
        return handle && arr.indexOf(handle) === index;
      });
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    var unique = list.map(String).filter(function (handle, index, arr) {
      return handle && arr.indexOf(handle) === index;
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list: unique } }));
  }

  function getHandle(btn) {
    return btn.getAttribute('data-handle') || btn.getAttribute('data-product-handle') || '';
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(String(handle)) !== -1;
  }

  function getWishlistUrl() {
    var link = document.querySelector('.js-wishlist-link');
    return (link && link.getAttribute('href')) || '/pages/wishlist';
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
      return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    }
    return '\u20B9' + Math.round(cents / 100);
  }

  function updateWishlistCount() {
    var count = getWishlist().length;
    document.querySelectorAll('.js-wishlist-count, [data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshHeartButtons() {
    var list = getWishlist();
    document.querySelectorAll('.js-btn-wishlist, [data-wishlist-toggle]').forEach(function (btn) {
      var handle = getHandle(btn);
      if (!handle) return;
      var active = list.indexOf(handle) !== -1;
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('title', active ? 'View wishlist' : 'Add to wishlist');
    });
    updateWishlistCount();
  }

  function toggleWishlist(handle) {
    handle = String(handle);
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
      saveWishlist(list);
      return true;
    }
    list.splice(idx, 1);
    saveWishlist(list);
    return false;
  }

  function renderWishlistPage() {
    var container = document.querySelector('.js-wishlist-content');
    if (!container) return;

    var token = ++renderToken;
    var list = getWishlist();
    container.innerHTML = '';

    if (!list.length) {
      container.innerHTML =
        '<div class="col-12 text-center">' +
          '<div class="alert alert-warning d-inline-block">There are no products in your wishlist!</div>' +
        '</div>';
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    list.forEach(function (handle) {
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        })
        .then(function (product) {
          if (token !== renderToken) return;

          var price = product.price_varies
            ? 'from ' + formatMoney(product.price_min)
            : formatMoney(product.price);
          var compare = product.compare_at_price_min
            ? '<s>' + formatMoney(product.compare_at_price_min) + '</s>'
            : '';
          var img = product.featured_image || '';

          var html =
            '<div class="js-wishlist-item col-md-4 col-sm-6 col-12 mb-4 pb-3">' +
              '<div class="js-wishlist-itembox">' +
                '<div class="d-flex flex-row">' +
                  '<a class="d-inline-block mr-4 wl-left" href="' + product.url + '">' +
                    '<img src="' + img + '" alt="" width="120" loading="lazy" />' +
                  '</a>' +
                  '<div>' +
                    '<a href="' + product.url + '" class="title-product d-block product-card__name mb-1">' + product.title + '</a>' +
                    '<span>' + price + '</span> ' + compare +
                    '<p><button type="button" class="btn js-wishlist-remove link px-0 small" data-handle="' + product.handle + '">Remove</button></p>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>';

          container.insertAdjacentHTML('beforeend', html);
        })
        .catch(function () {
          /* skip missing products */
        });
    });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.js-wishlist-remove');
    if (removeBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toggleWishlist(removeBtn.getAttribute('data-handle'));
      return;
    }

    var btn = e.target.closest('.js-btn-wishlist, [data-wishlist-toggle]');
    if (!btn) return;

    var handle = getHandle(btn);
    if (!handle) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (isInWishlist(handle)) {
      window.location.href = getWishlistUrl();
      return;
    }

    toggleWishlist(handle);
    btn.classList.add('active');
    btn.setAttribute('aria-pressed', 'true');
    btn.setAttribute('title', 'View wishlist');
    updateWishlistCount();
  }, true);

  document.addEventListener('wishlist:updated', function () {
    refreshHeartButtons();
    renderWishlistPage();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      refreshHeartButtons();
      renderWishlistPage();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshHeartButtons();
    renderWishlistPage();
  });

  window.Wishlist = {
    get: getWishlist,
    refresh: refreshHeartButtons,
    renderPage: renderWishlistPage
  };
})();
